<div #popupWrapper class="popup-wrapper">
  <ng-content>
  </ng-content>
</div>
